import React from "react";
import { useI18n } from "../i18n";

const IMG = "https://static.prod-images.emergentagent.com/jobs/ad03e093-9839-41bf-ac5b-862791f20158/images";

const IMGS = [
  `${IMG}/d231a59b736471181a60a4f500774ac5202510af2dd407898fa66726877e8ffa.jpeg`,
  `${IMG}/d39534a69e111d8add11d734ebaf6cf2069bbc41832f816382da1103580c2a11.jpeg`,
  `${IMG}/67478a4f882c4ba20021d458e3cda8b8dabdc5097559cb1ca87659bb2a597c49.jpeg`,
  `${IMG}/61ea963e148d4c1b9faa47c75864db3a91fcbc7fdfa64f2179e30120f0cbb9b8.jpeg`,
];

export function HowItWorks() {
  const { t } = useI18n();
  const STEPS = IMGS.map((img, i) => ({ n: i + 1, t1: t(`how4.s${i + 1}a`), t2: t(`how4.s${i + 1}b`), text: t(`how4.s${i + 1}x`), img }));
  return (
    <section data-testid="how-it-works" className="mb-14">
      <h2 className="font-anton text-3xl sm:text-4xl uppercase text-white text-center mb-8 tracking-wide">
        {t("how4.title1")} <span className="neon-text-green">{t("how4.title2")}</span>
      </h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {STEPS.map((s, i) => (
          <div
            key={s.n}
            data-testid="how-step"
            style={{ animationDelay: `${i * 90}ms` }}
            className="animate-fade-up group relative flex flex-col rounded-2xl border-2 border-neon-green/70 bg-ink-surface/80 p-3 sm:p-4 shadow-[0_0_18px_rgba(157,255,0,0.15)] hover:shadow-[0_0_30px_rgba(157,255,0,0.4)] hover:border-neon-green transition-all"
          >
            <span className="absolute -top-3 left-3 bg-ink px-2 font-anton text-neon-magenta text-lg leading-none">{s.n}.</span>
            <h3 className="font-anton uppercase text-white text-sm sm:text-lg leading-tight text-center mt-1 min-h-[2.5rem] sm:min-h-[3rem]">
              {s.t1}{" "}<span className="text-neon-green">{s.t2}</span>
            </h3>
            <div className="mt-3 aspect-square overflow-hidden rounded-xl bg-black">
              <img src={s.img} alt={`${s.t1} ${s.t2}`} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p className="text-zinc-400 text-[11px] sm:text-xs text-center mt-3 leading-snug">{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
